import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-meta-table-menu',
  templateUrl: './meta-table-menu.component.html',
  styleUrls: ['./meta-table-menu.component.css']
})
export class MetaTableMenuComponent implements OnInit {
    metaTableKeyno;

    public menu?: Menu;

    public selectListRelatedTo: RelatedToItem[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.metaTableKeyno = this.stateService.getStateParams()['metatable_keyno'];
    }

    private async loadMenu() {
        if (!!this.metaTableKeyno) {
            this.menu = (await this.datatask.Post(2375, { metatable_keyno: this.metaTableKeyno }))[0];
        }
    }

    private async loadRelatedTo(): Promise<void> {
        this.selectListRelatedTo = await this.datatask.Post(2373);
    }

    private async init() {
        this.loadMenu();
        this.loadRelatedTo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    metatable_keyno: number;
    metatable_name: string;
    metatable_table_name: string;
    table_name_related_to: string;
    nbr_of_columns: number;
}

interface RelatedToItem {
    table_name_related_to: string;
    table_name_related_to_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTableMenu', {
//        templateUrl: 'views/components/views/metaTableMenu/metaTableMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'metaTableMenuService', 'metaTableService', function ($stateParams, metaTableMenuService, metaTableService) {
//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            vm.model = {
//                menu: {},
//                selectListRelatedTo: []
//            };

//            async function loadMenu() {
//                vm.model.menu = (await metaTableMenuService.getMetaTableMenu({ metatable_keyno: metaTableKeyno }))[0];
//            }

//            async function loadRelatedToMetaTables() {
//                vm.model.selectListRelatedTo = await metaTableService.listRelatedToMetaTables();
//            }

//            vm.$onInit = function () {
//                loadMenu();
//                loadRelatedToMetaTables();
//            }
//        }]
//    });
//})();
